import {
  Box,
  IconButton,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import VisibilityIcon from "@mui/icons-material/Visibility";
import axios from "axios";
import { AUDIT_AGENT_PERFORMANCE } from "../../constants";
import NewReleasesIcon from "@mui/icons-material/NewReleases";
import VerifiedIcon from "@mui/icons-material/Verified";
import OpenRemarkList from "./OpenRemarksList";
import ClosedRemarkList from "./ClosedRemarksList";
import CompletedFollowupList from "./CompletedFollowupList";
import PendingFollowupList from "./PendingFollowupList";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import FilterComponent from "./FilterCompoent";
import SupFilterComponent from "./SupFilterComponent";
import FilterListIcon from "@mui/icons-material/FilterList";
import Loader from "../reusable Component/Loader";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
};

const buttonStyle = {
  border: "1px solid #fff",
  borderRadius: "4px",
  margin: "5px",
  width: "40px",
  height: "40px",
  justifyContent: "center",
  alignItems: "center",
  backgroundColor: "#097969",
  color: "#fff",
  transition: "background-color 0.3s, transform 0.2s",
  boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.2)",
};

const hoverEffects = (e, isHovering) => {
  e.currentTarget.style.backgroundColor = isHovering ? "#0B9B73" : "#097969";
  e.currentTarget.style.transform = isHovering ? "scale(1.05)" : "scale(1)";
};

function AgentFollowupReportComponent({}) {
  const navigate = useNavigate();
  const empDetails = JSON.parse(localStorage.getItem("userData"));

  const [completedFollowupData, setCompletedFollowupData] = useState([]);
  const [completedCount, setCompletedCount] = useState(0);
  const [pendingFollowupData, setPendingFollowupData] = useState([]);
  const [pendingCount, setPendingCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [sortColumn, setSortColumn] = useState(null);
  const [data, setData] = useState([]);
  const [sortDirection, setSortDirection] = useState("asc"); // "asc" or "desc"
  const [filters, setFilters] = useState({
    startDate: "",
    endDate: "",
    agentName:
      localStorage.getItem("empRole") === "100" ? empDetails.EmployeeName : "",
  });

  const fetchRemarkReportData = async () => {
    setLoading(true);
    try {
      const { startDate, endDate, agentName } = filters;

      // Build query parameters dynamically
      const queryParams = new URLSearchParams();
      if (startDate) queryParams.append("startDate", startDate);
      if (endDate) queryParams.append("endDate", endDate);
      if (localStorage.getItem("empRole") === "100") {
        queryParams.append("agentName", empDetails.EmployeeName);
      } else {
        if (agentName) queryParams.append("agentName", agentName);
      }

      const response = await axios.get(
        `${AUDIT_AGENT_PERFORMANCE}?${queryParams.toString()}`
      );
      setData(response.data.data);
      setCompletedFollowupData(response.data.data.details.followups.completed);
      setCompletedCount(
        localStorage.getItem("empRole") === "100"
          ? response.data.data.agent_wise_summary[0].counts.followups.completed
          : response.data.data.summary.followup_statistics.completed_followups
      );
      setPendingFollowupData(response.data.data.details.followups.pending);
      setPendingCount(
        localStorage.getItem("empRole") === "100"
          ? response.data.data.agent_wise_summary[0].counts.followups.pending
          : response.data.data.summary.followup_statistics.pending_followups
      );
      setLoading(false);
    } catch (error) {
      console.error("Error fetching data", error);
      setData([]);
      setCompletedFollowupData([]);
      setCompletedCount(0);
      setPendingFollowupData([]);
      setPendingCount(0);
    } finally {
      setLoading(false);
    }
  };

  const location = useLocation();
  const activeTab = location.state?.activeTab || 0;
  const prevFilters = location.state?.prevFilters; // Check if prevFilters exist
  const [value, setValue] = useState(activeTab);
  const [isFiltersInitialized, setIsFiltersInitialized] = useState(false);

  useEffect(() => {
    // Set filters from prevFilters or default values
    if (prevFilters && !isFiltersInitialized) {
      setFilters(prevFilters);
      setIsFiltersInitialized(true); // Mark as initialized
    } else if (!isFiltersInitialized) {
      // Set default values if prevFilters are not present
      setFilters({
        startDate: dayjs().subtract(7, "days").format("YYYY-MM-DD"),
        endDate: dayjs().format("YYYY-MM-DD"),
        agentName:
          localStorage.getItem("empRole") === "100"
            ? empDetails.EmployeeName
            : "",
      });
      setIsFiltersInitialized(true); // Mark as initialized
    }
  }, [prevFilters, isFiltersInitialized]);

  useEffect(() => {
    // Trigger fetch when filters are initialized
    if (isFiltersInitialized) {
      fetchRemarkReportData(); // Call the API after initialization
    }
  }, [filters, isFiltersInitialized]); // Ensure fetch is triggered when filters change

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [filterShow, setFilterShow] = useState(false);

  return (
    <>
    {loading && <Loader open={loading} />}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          width: "100%",
          marginBottom: 1,
        }}
      >
        {/* Title */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, paddingLeft: "12px", flexGrow: 1 }}
        >
          Follow-up Detail Report
        </Typography>

        {/* Filters */}
        {filterShow &&
          (localStorage.getItem("empRole") === "100" ? (
            <FilterComponent
              filters={filters}
              setFilters={setFilters}
              data={data}
              setFilterShow={setFilterShow}
            />
          ) : (
            <SupFilterComponent
              filters={filters}
              setFilters={setFilters}
              data={data}
              setFilterShow={setFilterShow}
            />
          ))}

        {/* Filter Icon */}
        <IconButton
          onClick={() => setFilterShow((prev) => !prev)}
          style={buttonStyle}
          onMouseEnter={(e) => hoverEffects(e, true)}
          onMouseLeave={(e) => hoverEffects(e, false)}
        >
          <FilterListIcon />
        </IconButton>
      </Box>

      <Tabs
        value={value}
        onChange={handleChange}
        aria-label="wrapped label tabs example"
      >
        <Tab
          label={`Completed (${completedCount || 0})`}
          id="tab-0"
          icon={<VerifiedIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
        <Tab
          label={`Pending (${pendingCount || 0})`}
          id="tab-1"
          icon={<AccessTimeIcon />}
          iconPosition="start"
          aria-controls="tabpanel-1"
        />
      </Tabs>
      <TabPanel value={value} index={0}>
        <CompletedFollowupList
          completedFollowupData={completedFollowupData}
        ></CompletedFollowupList>
      </TabPanel>

      <TabPanel value={value} index={1}>
        <PendingFollowupList
          pendingFollowupData={pendingFollowupData}
        ></PendingFollowupList>
      </TabPanel>
    </>
  );
}

export default AgentFollowupReportComponent;
